import React, { useState } from "react";
import Price from "./Price";
import Users from "./Users";
import Referrals from "./Referrals";
import Notifications from "./Notifications";

const AdminPanel = () => {
    const [activeTab, setActiveTab] = useState("users"); // по умолчанию "Пользователи"

    return (
        <div>
            {/* Меню */}
            <div style={{
                display: "flex",
                justifyContent: "center",
                gap: "40px",
                marginTop: "15px",
                borderBottom: "1px solid #ccc",
                paddingBottom: "10px"
            }}>
                <span
                    onClick={() => setActiveTab("users")}
                    style={{
                        cursor: "pointer",
                        fontWeight: activeTab === "users" ? "bold" : "normal",
                        color: activeTab === "users" ? "#007bff" : "#333",
                        borderBottom: activeTab === "users" ? "2px solid #007bff" : "none",
                        paddingBottom: "5px"
                    }}
                >
                    Пользователи
                </span>
                <span
                    onClick={() => setActiveTab("price")}
                    style={{
                        cursor: "pointer",
                        fontWeight: activeTab === "price" ? "bold" : "normal",
                        color: activeTab === "price" ? "#007bff" : "#333",
                        borderBottom: activeTab === "price" ? "2px solid #007bff" : "none",
                        paddingBottom: "5px"
                    }}
                >
                    Прайс
                </span>
                <span
                    onClick={() => setActiveTab("referrals")}
                    style={{
                        cursor: "pointer",
                        fontWeight: activeTab === "referrals" ? "bold" : "normal",
                        color: activeTab === "referrals" ? "#007bff" : "#333",
                        borderBottom: activeTab === "referrals" ? "2px solid #007bff" : "none",
                        paddingBottom: "5px"
                    }}
                >
                    Рефералка
                </span>
                <span
                    onClick={() => setActiveTab("notifications")}
                    style={{
                        cursor: "pointer",
                        fontWeight: activeTab === "notifications" ? "bold" : "normal",
                        color: activeTab === "notifications" ? "#007bff" : "#333",
                        borderBottom: activeTab === "notifications" ? "2px solid #007bff" : "none",
                        paddingBottom: "5px"
                    }}
                >
                    Уведомления
                </span>
            </div>

            {/* Контент */}
            <div style={{ padding: "0 40px" }}>
                {activeTab === "users" && <Users />}
                {activeTab === "price" && <Price />}
                {activeTab === "referrals" && <Referrals />}
                {activeTab === "notifications" && <Notifications />}
            </div>
        </div>
    );
};

export default AdminPanel;

